import React from 'react';
import { SalesTargetPanel } from '../components/SalesTargetPanel';

export const MontoDiarioPage: React.FC = () => {
  return <SalesTargetPanel />;
};
